<template>
  <app-layout >
      <div class="max-w-7xl mx-auto  my-5 py-4" style="background-color:#F9FFFE">
          <div class="h-80 p-5">
              <div class="text-center place-content-center">
                  <img
                  :src="'/imgs/sync.png'"
                  alt="Update"
                  class="inline"
                  
                  />
                  <br />
                  <h4 class="text-center update font-semibold mt-5">Updates Available</h4>
                  <div class="text-center">
                  <div class=" inline-block mx-auto">
                      <p class="text-sm font-semibold text-center mx-auto text-gray-700" style="width:60%">
                          Get ready to unlock new features that will help you streamline your workflow and achieve your goals even faster
                      </p>
                  </div>
              </div class="my-4">
                  <button href="#" type="button" class="rounded font-bold  text-white px-4 py-2 my-3" style="background-color:#57A777">
                   Update Now
                <!-- &laquo; &nbsp; -->
                 </button>
              </div>        
          </div>
      
      </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
export default {
components: {
  AppLayout
}

 
}

</script>

<style>
.update{
 margin-bottom: .1rem;
}

</style>